<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  // beforeCreate() {
  //   let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"))
  //   if(userInfo){
  //     this.$store.dispatch('getDynamicMenuRoutes', userInfo)
  //     this.$router.addRoutes([...this.$store.state.permission.addRouters])      
  //   }  
  // }
}
</script>

<style lang="less">
  @import './style/index';
  #app{
    height: 100%;
  }
  .el-table--border th.gutter:last-of-type { display: block!important; width: 17px!important; }
</style>
